import type { CustomFieldType, ICustomFieldDefinition, ILocalizedText, IOverrideOption } from '@platform/core/types';
import { customFieldKey } from './customFieldKey';

/**
 * Нове власне поле простору з рядка «+ Додати поле» (прототип v4 addField → fd()): ключ cf_… за підписом (унікальний серед `taken`), підпис
 * мовою інтерфейсу, тип, «У списку» (колонка таблиці модуля, як inTable: true прототипу), необов'язкове; поле вибору — з варіантами. Чиста функція.
 */
export function newCustomField(label: string, type: CustomFieldType, taken: readonly string[], lang: string, options?: IOverrideOption[]): ICustomFieldDefinition {
  return { key: customFieldKey(label, taken), label: { [lang]: label } as unknown as ILocalizedText, type, inList: true, ...(options ? { options } : {}) };
}
